import { fetchme } from 'gso-fetchme';
import { read } from 'gso-session';

const cache = {};
function getEntrypoint(name, options) {
    if (cache[name]) {
        return Promise.resolve(cache[name]);
    }
    const url = read('servers')[name].links.entrypoint;
    return fetchme(url, options).then(entrypoint => {
        cache[name] = entrypoint;
        return entrypoint;
    });
}
function cleanEntrypoint(name) {
    return name ? delete cache[name] : false;
}

export { cleanEntrypoint, getEntrypoint };
//# sourceMappingURL=get-entrypoint.esm.js.map
